/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import * as safeJsonStringifyModule from 'safe-json-stringify';
/* istanbul ignore next */
var safeJsonStringify = safeJsonStringifyModule.default || safeJsonStringifyModule;
export { safeJsonStringify };
//# sourceMappingURL=safe-stringify.js.map